import React, { useEffect, useRef } from "react";

function ScaleNormalizer({ children, scaleFactor = 1 }) {
  const wrapperRef = useRef(null);
  

  useEffect(() => {
    const applyScaleFix = () => {
      const wrapper = wrapperRef.current;
      if (!wrapper) return;

      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      wrapper.style.transform = "";
      wrapper.style.zoom = "";

      if (!isMobile && window.devicePixelRatio !== 1) {
        let scale = (1 / window.devicePixelRatio) * scaleFactor;

        if ("zoom" in document.body.style) {
          wrapper.style.zoom = scale;
        } else {
          wrapper.style.transform = `scale(${scale})`;
          wrapper.style.transformOrigin = "top left";
        }
      }
    };

    applyScaleFix();
    window.addEventListener("resize", applyScaleFix);
    return () => window.removeEventListener("resize", applyScaleFix);
  }, [scaleFactor]);

  return (
    <div
      ref={wrapperRef}
      style={{
        width: "100%",
        transformOrigin: "top left",
        position: "relative",
      }}
    >
      {children}
    </div>
  );
}

export default ScaleNormalizer;
















// import React, { useEffect, useRef } from "react";

// function ScaleNormalizer({ children }) {
//   const wrapperRef = useRef(null);

//   useEffect(() => {
//     const applyScaleFix = () => {
//       const wrapper = wrapperRef.current;
//       if (!wrapper) return;

//       const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

//       wrapper.style.transform = "";
//       wrapper.style.zoom = "";

//       if (!isMobile && window.devicePixelRatio !== 1) {
//         // Base scale from system DPI
//         let scale = 1 / window.devicePixelRatio;

//         // 🧮 Adjust manually here (0.8 = 80%, 0.7 = 70%, etc.)
//         const manualAdjust = 0.85; // try 0.7 or 0.6 if you want smaller content
//         scale *= manualAdjust;

//         // ✅ Apply scaling
//         if ("zoom" in document.body.style) {
//           wrapper.style.zoom = scale;
//         } else {
//           // Firefox fallback
//           wrapper.style.transform = `scale(${scale})`;
//           wrapper.style.transformOrigin = "top left";
//         }
//       }
//     };

//     applyScaleFix();
//     window.addEventListener("resize", applyScaleFix);
//     return () => window.removeEventListener("resize", applyScaleFix);
//   }, []);

//   return (
//     <div
//       ref={wrapperRef}
//       id="scale-normalizer-wrapper"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         overflowX: "hidden",
//         transformOrigin: "top left",
//         position: "relative",
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// export default ScaleNormalizer;
